import { Col } from "react-bootstrap";
import AspectRatio from "components/aspect-ratio";
import getClasses from "utils/getClasses";
import styles from "./styles.module.scss";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  general: boolean;
  isInDashboardHome: boolean;
};
const BreakdownBlock = ({ children, general, isInDashboardHome }: Props) => (
  <Col className={styles["breakdown-block"]}>
    <AspectRatio
      ratio={isInDashboardHome ? 1.36 : 1.7}
      wrapperClassName={getClasses(
        !general &&
          isInDashboardHome &&
          styles["breakdown-block__wrapper--cancelled"],
        isInDashboardHome
          ? styles["breakdown-block__wrapper"]
          : styles["breakdown-block__wrapper--ba-tab"],
      )}
      contentClassName={styles["breakdown-block__content"]}
    >
      {children}
    </AspectRatio>
  </Col>
);
export default BreakdownBlock;
